import React, { useState } from 'react';
import { Download, Lock } from 'lucide-react';
import { exportActivityData, exportProjectsData, exportReceivedAirdrops, exportSummaryReport } from '../utils/exportData';

export const ExportButton = ({ 
  weeklyData, 
  projectSettings, 
  receivedAirdrops, 
  stats, 
  roiCalculation, 
  showToast, 
  isDark, 
  colors,
  isPro,
  openPricing
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleExport = (type) => {
    if (!isPro) {
      setIsOpen(false);
      if (openPricing) openPricing();
      return;
    }

    switch(type) {
      case 'summary':
        exportSummaryReport(weeklyData, projectSettings, receivedAirdrops, stats, roiCalculation);
        break;
      case 'activity':
        exportActivityData(weeklyData);
        break;
      case 'projects':
        exportProjectsData(projectSettings);
        break;
      case 'received':
        exportReceivedAirdrops(receivedAirdrops);
        break;
    }
    showToast('Data exported successfully!');
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-3 py-2 rounded-lg font-medium text-sm transition-colors ${
          isDark 
            ? 'bg-green-600 hover:bg-green-700 text-white' 
            : 'bg-green-500 hover:bg-green-600 text-white'
        }`}
      >
        <Download size={16} />
        Export
        {!isPro && <Lock size={12} className="ml-1" />}
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className={`absolute right-0 mt-2 w-48 rounded-lg shadow-lg z-50 border ${
            isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200'
          }`}>
            {!isPro && (
              <div className={`px-4 py-2 text-xs border-b ${isDark ? 'border-slate-700 text-yellow-400' : 'border-gray-200 text-yellow-600'}`}>
                🔒 Pro feature - Upgrade to export
              </div>
            )}
            <button
              onClick={() => handleExport('summary')}
              className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                isDark ? 'hover:bg-slate-700 text-slate-200' : 'hover:bg-gray-100 text-gray-700'
              }`}
            >
              Summary Report
            </button>
            <button
              onClick={() => handleExport('activity')}
              className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                isDark ? 'hover:bg-slate-700 text-slate-200' : 'hover:bg-gray-100 text-gray-700'
              }`}
            >
              Activity History
            </button>
            <button
              onClick={() => handleExport('projects')}
              className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                isDark ? 'hover:bg-slate-700 text-slate-200' : 'hover:bg-gray-100 text-gray-700'
              }`}
            >
              Projects
            </button>
            <button
              onClick={() => handleExport('received')}
              className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                isDark ? 'hover:bg-slate-700 text-slate-200' : 'hover:bg-gray-100 text-gray-700'
              }`}
            >
              Received Airdrops
            </button>
          </div>
        </>
      )}
    </div>
  );
};